(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('olmRequisition', {
        templateUrl: 'views/components/views/olmRequisition/olmRequisition.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'olmRequisitionService', 'requisitionCreateService', function ($stateParams, stateService, utilityService, olmRequisitionService, requisitionCreateService) {
            const vm = this;
            let olmKeyno = $stateParams.olm_keyno;

            vm.model = {
                orderButtons: [
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.menu.order_internal_no }) }
                ],
                menu: {},
                itemsListStocks: []
            };
            
            async function loadMenu() {
                vm.model.menu = (await olmRequisitionService.getMenu({ olm_keyno: olmKeyno }))[0];
            }
            
            async function loadStocks() {
                if (utilityService.validateParmsValue(vm.model.menu.stock_keyno_to) !== true) return;
                
                return vm.model.itemsListStocks = await olmRequisitionService.listStocks({ stock_keyno_to: vm.model.menu.stock_keyno_to });
            }
            
            vm.goBackToPrevious = function (item) {
                item = item?.item ? item.item : item;

                requisitionCreateService.createRequisition({
                    stock_keyno_from: item.stock_keyno,
                    stock_keyno_to: vm.model.menu.stock_keyno_to,
                    quantity: vm.model.menu.quantity,
                    olm_keyno: vm.model.menu.olm_keyno
                }).then(function () {
                    stateService.back();
                });
            }

            vm.$onInit = async function () {
                await loadMenu();
                loadStocks();
            }
        }]
    });
})();
